<mch-shell-topbar class="topbar"></mch-shell-topbar>
<mch-shell-rail class="rail"></mch-shell-rail>
<main class="content">
	<!-- Every page renders on this surface. Without it, page text sits directly
	     on the background image and gets lost in it. -->
	<div
		class="page-surface"
		[class.surface-narrow]="surface() === 'narrow'"
		[class.surface-form]="surface() === 'form'"
	>
		<router-outlet></router-outlet>
	</div>
</main>
